import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { StyledScrollContainer } from '../../../../components/StyledScrollContainer';
import { DialogVehicleDeliveryConfirmation } from '../../../../components/DialogVehicleDeliveryConfirmation';

// @components
import {
    Avatar,
    Button,
    Typography,
    Card,
} from "@material-tailwind/react";
import { Refresh } from "iconoir-react";
import {
    Vehicle,
    listVehiclesDeliveryRequest,
} from "../../../../redux/vehicles/actions";
import { RootState } from '../../../../redux';


const TABLE_HEAD = [
    {n: "Name", className: "w-30"},
    {n: "VIN", className: "w-30"},
    {n: "ETA", className: "w-30 text-center"},
    {n: "", className: "w-20"},
];

const DashboardVehicleDelivery = () => {
    const dispatch = useDispatch();
    const { deliveries } = useSelector((state: RootState) => state.vehicles);
    const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
    const [openDialog, setOpenDialog] = useState(false);

    const handleRefresh = () => {
        dispatch(
            listVehiclesDeliveryRequest({
                vehicle_fields: [
                    "id",
                    "status",
                    "display_status",
                    "is_listed",
                    "ymmt",
                    "thumbnail",
                    "make",
                    "model",
                    "vin",
                    "inspection_score",
                    "inspection_results",
                    "parts",
                    "tasks",
                    "labors",
                    "delivery_company",
                    "delivery_order",
                    "delivery_pickup_date",
                    "delivery_est_date",
                    "delivery_date",
                ].join(","),
            })
        );
    };

    useEffect(() => {
        handleRefresh();
    }, [dispatch]);

    return (
        <div className="flex flex-col gap-y-5 mt-5 text-black w-full">
            <Card>
                <Card.Header className="w-full m-0 items-center rounded-none flex  justify-between p-4">
                    <div className="grow">
                        <Typography
                            type="lead"
                            color="default"
                            className="font-semibold mb-1"
                        >
                            Vehicles Deliveries
                        </Typography>
                        <Typography type="small" className="text-foreground block">
                            All expected vehicle deliveries
                        </Typography>
                    </div>
                    <div className="flex flex-col sm:flex-row items-center w-full shrink-0 gap-3 md:w-max">
                        <Button
                            variant="outline"
                            color="secondary"
                            className="flex items-center gap-2 sm:w-auto w-full"
                            onClick={() => {
                                handleRefresh();
                            }}
                        >
                            <Refresh className="w-4 h-4" />
                        </Button>
                    </div>
                </Card.Header>
                <StyledScrollContainer className="max-h-[400px]">
                    <Card.Body className="p-0 rounded-none">
                        <table className="w-full min-w-max table-auto text-left">
                            <thead>
                                <tr>
                                    {TABLE_HEAD.map((head, idx:number) => (
                                        <th key={idx} className={`border-b border-surface p-4 ${head.className}`}>
                                            <Typography
                                                type="small"
                                                color="default"
                                                className="block font-medium"
                                            >
                                                {head.n}
                                            </Typography>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {deliveries.map((el: Vehicle, key: number) => (
                                    <tr key={key} className="group">
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <div className="flex items-center gap-3">
                                                <Avatar src={el?.thumbnail?.full_url} alt={el?.ymmt} shape="rounded" />
                                                <div className="space-y-1">
                                                    <Typography
                                                        type="small"
                                                        color="default"
                                                        className="font-semibold block overflow-hidden w-20 text-ellipsis text-nowrap"
                                                    >
                                                        {el?.ymmt || 'N/A'}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground w-30 overflow-hidden text-ellipsis text-nowrap">
                                                {el.vin}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="text-center block text-foreground">
                                                {el.delivery_est_date || 'N/A'}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Button
                                                size="xs"
                                                variant="outline"
                                                color="secondary"
                                                className="border-[#E2E8F0]"
                                                onClick={() => {
                                                    setSelectedVehicle(el);
                                                    setOpenDialog(true);
                                                }}
                                            >
                                                Delivered
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </StyledScrollContainer>

                <DialogVehicleDeliveryConfirmation
                    vehicle={selectedVehicle}
                    setIsOpen={setOpenDialog}
                    isOpen={openDialog}
                />

            </Card>
        </div>
    );
};

export default DashboardVehicleDelivery;